import { VIEW, ViewType } from 'types/deck'

export const CARD_DIMENSIONS = {
  HEIGHT: 311,
  WIDTH: 223,
  COLLAPSED_HEIGHT: 35,
  EXPANDED_HEIGHT: 361,
  RADIUS: 12,
  HEADER_HEIGHT: 45,
}

export const TEXT_CARD_DIMENSIONS = {
  HEIGHT: 25,
  HEADER_HEIGHT: 45,
  UNDERLINE_HEIGHT: 2,
  UNDERLINE_BOTTOM: 7,
  DROPDOWN_HEIGHT: 175,
}

export const getStackHeight = (viewType: ViewType, cardCount: number) => {
  if (viewType === VIEW.CARD || viewType === VIEW.BREWING)
    return (
      (cardCount - 1) * CARD_DIMENSIONS.COLLAPSED_HEIGHT +
      CARD_DIMENSIONS.EXPANDED_HEIGHT +
      CARD_DIMENSIONS.HEADER_HEIGHT
    )

  if (viewType === VIEW.TEXT) return cardCount * TEXT_CARD_DIMENSIONS.HEIGHT + CARD_DIMENSIONS.HEADER_HEIGHT

  return 0
}
